import React from 'react';
import { observer } from 'mobx-react-lite';
import { colors } from '@insurancemenu/imenu-components-lib';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import CreateRFQTemplateModal from '../modals/CreateRFQTemplateModal';
import { PRODUCT_TEMPLATES_ADD_PRODUCT_BTN_TEST_ID } from '../constants';
import { ButtonsContainerStyled, ButtonStyled } from './styles';

export const ProductTemplatesActions: React.FC = observer(() => {
  const { openCreateTemplateModal } = useRFQProductTemplatesStore();

  return (
    <>
      <ButtonsContainerStyled>
        <ButtonStyled
          color="custom"
          customColor={colors.green[600]}
          leftIconProp={<Add />}
          onClick={openCreateTemplateModal}
          size="large"
          data-test-id={PRODUCT_TEMPLATES_ADD_PRODUCT_BTN_TEST_ID}
        >
          Add Product Template
        </ButtonStyled>
      </ButtonsContainerStyled>

      <CreateRFQTemplateModal />
    </>
  );
});
